import api from "../config/api"


export const getVendorById = async (id) => {
    const res = await api.get(`/vendor/?id=${id}`);
    return res.data;
}

export const getAllVendors = async () => {
    const res = await api.get('/vendor/');
    return res.data;
}

export const deleteVendor = async (id) => {
    const res = await api.delete(`/vendor/?id=${id}`);
    return res.data;
}
export const saveVendor = async (data) => {
    const response = await api.post(`/vendor/`,data,{
        headers:{"Content-Type":"application/json"}
    });
    return response.data;
}